import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { fill: "none", width: 24, height: 24, viewBox: "0 0 24 24", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 2, d: "M20 9.7C20 16 12.5 23 12.5 23S5 16 5 9.7c0-2.042.79-4 2.197-5.445A7.403 7.403 0 0 1 12.5 2a7.4 7.4 0 0 1 5.303 2.255A7.805 7.805 0 0 1 20 9.7Z M12.5 12.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }) });
export {
  t as default
};
//# sourceMappingURL=map-pin.js.map
